<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        <span class="p-float-label size_cent">
          <div>{{'Screen' | translate}} *</div>
          <p-dropdown
            formControlName="name"
            [style]="{ width: '100%' }"
            [options]="screenList"
            filter="true"
            placeholder="{{'Sel_Scre' | translate}}"
          ></p-dropdown>
        </span>
        <span class="p-float-label size_cent form-margin">
          <input formControlName="label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Lab_Menu' | translate}} *</label>
        </span>
        <span class="p-float-label size_cent form-margin">
          <div>{{'Access' | translate}} *</div>
          <p-dropdown
            formControlName="visibility"
            [options]="listVisibility"
            (onChange)="onChangeVisibility($event)"
            placeholder="{{'Sel_Typacc' | translate}}"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </span>
      </div>
      <div class="p-field col-12 md:col-6">
        <div>{{'Desc' | translate}}</div>
        <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
        <label for="typeitem">{{'Dock' | translate}} </label>
        <p-inputSwitch inputId="typeitem" formControlName="typeitem" ></p-inputSwitch>
      </div>
    </div>
    <div class="col-12">
      @if (visibility === 1) {
        <div class="col-4">
          <div class="center-text">{{'List_Grp' | translate}}</div>
          <p-listbox
            formControlName="groupListUsed"
            [options]="groupList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '30vh' }"
            scrollHeight="30vh"
            >
          </p-listbox>
        </div>
      }
      @if (visibility === 2) {
        <div class="col-4">
          <div class="center-text">{{'List_Usr' | translate}}</div>
          <p-listbox
            formControlName="userListUsed"
            [options]="userList"
            multiple="multiple"
            checkbox="checkbox"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            [listStyle]="{ width: '100%', height: '30vh' }"
            >
          </p-listbox>
        </div>
      }
    </div>
  </form>
</div>

<div class="foo-ter col-12 lg:col-12 md:col-12 align-right">
  @if (resultForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
